/**
 * 青山科技页面
 */
import React from 'react';
import Guide from './guide';
import { APPLY_YEAR } from '../../../utils/config';
import './application.scss';
import AwardHeader from '../../../components/AwardHeader/AwardHeader';

const Application = () => (
    <div className="award-application">
      <AwardHeader />
      <div className="about-award block-container marker" style={{ marginTop: 150 }}>
        <span className="title">{`青山科技奖申报指南（${APPLY_YEAR}年度）`}</span>
        <div className="regulation">
          <Guide />
        </div>
      </div>
    </div>
  );

export default Application;
